<template>
  <v-card
    variant="flat"
    class="tw-border tw-rounded-3xl tw-border-primary-200 tw-px-6 tw-py-4 tw-group tw-transition-all tw-duration-300 hover:tw-border-primary-500 hover:tw-shadow-md hover:tw-shadow-primary-500/15"
  >
    <v-card-title
      class="tw-flex tw-items-center tw-text-sm tw-text-primary-500 tw-font-semibold tw-p-0 tw-gap-3 tw-mb-3"
    >
      <span>{{ plan.name }}</span>
      <v-chip
        v-if="plan.discount"
        size="small"
        class="tw-text-xs tw-h-[22px] tw-rounded-md tw-px-2 tw-py-0.5 tw-text-success-600 tw-bg-success-500/20"
      >
        {{ plan.discount }}
      </v-chip>
    </v-card-title>
    <v-card-text class="tw-p-0">
      <v-row no-gutters>
        <v-col class="tw-grow tw-tracking-normal">
          <div
            class="tw-text-xl tw-text-slate-500 group-hover:tw-text-slate-600 tw-whitespace-nowrap"
          >
            <span>{{ plan.currencySymbol }}</span>
            <span class="tw-font-bold">
              {{
                formatNumber(plan.formattedPrice, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </div>
          <div class="tw-text-xs tw-text-slate-400 tw-mb-0.5">
            {{ plan.billingPeriodText }}
          </div>
          <div class="tw-text-xs tw-text-slate-400">
            {{ plan.smallDescription }}
          </div>
        </v-col>
        <v-col class="tw-flex tw-justify-end tw-grow-0">
          <v-btn
            variant="outlined"
            color="primary"
            size="large"
            :loading="isCreatingCheckoutSession"
            class="tw-text-sm tw-font-semibold tw-px-4 tw-py-2 tw-rounded-full group-hover:tw-bg-primary-500 group-hover:tw-text-white"
            @click="openStripeCheckout"
          >
            {{ $t('pricingPlans.subscribeNow') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useI18n } from '@/composables/useI18n'
import { useCreateCheckoutSession } from '@/api/stripe/mutations'
import { useToast } from 'vue-toastification'

const {
  mutateAsync: createCheckoutSession,
  isPending: isCreatingCheckoutSession,
  isError: isCreatingCheckoutSessionError,
} = useCreateCheckoutSession()
const { formatNumber } = useI18n()
const toast = useToast()

const { plan } = defineProps({
  plan: {
    type: Object,
    required: true,
  },
})

const openStripeCheckout = async () => {
  try {
    const checkoutSession = await createCheckoutSession({
      priceId: plan.priceId,
    })
    console.log('checkoutSession', checkoutSession.url)
    window.open(checkoutSession.url, '_blank')
  } catch (error) {
    console.error(isCreatingCheckoutSessionError)
    if (error?.response?.data?.code === 'INVALID_PRICE') {
      toast.error('Plano indisponível no momento.')
      return
    }
    toast.error('Ops! Algo deu errado.')
  }
}
</script>

<style lang="scss" scoped></style>
